import { createContext } from 'react';

interface MeasurementContext {
  isMetric: boolean;
  setIsMetric: (newValue: boolean) => void;
}

export const MeasurementContext = createContext<MeasurementContext>({
  isMetric: false,
  setIsMetric: () => null,
});
